<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-0">

    <div class="row">
      <div class="col px-0">
        <div class="select_container" style="float:left">
          <select required class="form-control" v-bind:id="'select_' +  getId()" data-fouc v-on:change="onChange" v-select>
            <option value="" style="">{{placeholder}}</option>
            <option v-for="option in items" v-bind:value="option.locationid">
              {{ option.locationname }}
            </option>
          </select>
        </div>
          
        
        <button v-if="displayAddButton" type="button" class="btn skin primary-button btn-icon ml-1" @click="displayForm" style="float:right"><i class="icon-plus3"></i></button>

      </div>
    </div>

    <div class="row">
      <div class="input-container col-sm-12 px-0" v-if="displayAdd == true" style="float:left;">
        <input type="text" v-bind:placeholder="$store.translate('location_name')" class="form-control" v-model="itemName">
      </div>

      <div class="text-right col-sm-12 px-0" v-if="displayAdd == true" style="float:right;">
        <button type="submit" class="btn skin primary-button mt-1" @click="createItem">{{buttontext}}</button>
      </div>
    </div>
    

    <div v-if="message != null && message != ''" class="col-12 alert alert-light upload-error-message" role="alert">
      <ul>
        <li class="col-12" v-for="(ms, i) in message.split('\n')" :key="i">
          {{ ms }}
        </li>
      </ul>
    </div>

  </div>
</template>

<script>


  let message = "";
  let displayAdd = false;
  var items = [];
  var itemName = "";
  var placeholder = "";
  var buttontext = "";
  var displayAddButton = true;
  export default {
    name: "location-selector",
    props: {      
      value: {
        type: String,
        default: null
      },
      displayAddButton: {
        type: Boolean,
        default: true
      },
      loadDataOnInit: {
        type: Boolean,
        default: true
      },
      showSublocations: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        placeholder,
        buttontext,
        message: "",
        visible: this.visibility,
        displayAdd,
        itemName,
        items
      };
    },
    methods: {
      clearFields() {
        $("#select_" + this.getId()).val('');
        $("#select_" + this.getId()).trigger('change');
      },
      selectLocation(selected) {        
        $("#select_" + this.getId()).val(selected);
        $("#select_" + this.getId()).trigger('change');
      },
      fetchReloadData(value) {
        this.load(value);
      },
      displayForm() {
        this.displayAdd = !this.displayAdd;
      },
      getOptionStyle(v) {
        return v;
      },
      onChange() {
        this.$emit('change', $("#select_" + this.getId()).val(), $("#select_" + this.getId() + " option:selected").text());
      },
      input(event) {
      },
      getId() {
        return this._uid;
      },
      doChange() {
      },
      getData() {
        return this.items;
      },
      async createItem() {
        var request = { name: this.itemName };
        try {
          var response = await this.$http.post(
            '/api/location/Create',
            request
          ).then(async response => {
            this.load(response.data.Id);
            this.displayAdd = false;
          });

        } catch (err) {
          alert(err);
        }
      },
      async delete(id) {
        try {
          this.items = [];
          this.$http.get('/api/location/Delete?id='+ id).then(async response => {
          });
        } catch (err) {
          alert('some error:' + err)
        }
      },
      async load(selected) {
        try {
          this.items = [];
          var thisContext = this;
          this.$http.get('/api/Locations/v1?').then(response => {
            var locs = response.data;
            if (locs !== null && locs.length > 0) {
              locs = locs.sort(function (a, b) {
                var x = a.locationname.toLowerCase();
                var y = b.locationname.toLowerCase();
                return x < y ? -1 : x > y ? 1 : 0;
              });
            }
            thisContext.items = [];

            if (locs !== null && locs.length > 0) {
              locs.forEach(loc => {
                if (loc.ParentId === null) {
                  thisContext.items.push(loc);
                  if (this.showSublocations) {
                    var childLocs = locs.filter(n => n.ParentId == loc.locationid);
                    childLocs.forEach(subloc => {
                      subloc.locationname = loc.locationname + ' > ' + subloc.locationname;
                      thisContext.items.push(subloc);
                    });
                  }
                }
              });
            }


            $('#' + 'select_' + thisContext.getId()).select2();
            thisContext.$emit('eventdata', thisContext.items != undefined && thisContext.items != null ? thisContext.items.length : 0);
          }).then((response => {
            if (selected != null) {
              $("#select_" + thisContext.getId()).val(selected);
              $("#select_" + thisContext.getId()).trigger('change');
            }
          }
          ));
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      value: function (newVal, oldVal) {
        $("#select_" + this.getId()).val(newVal);
        $("#select_" + this.getId()).trigger('change');
      }
    },
    mounted() {
      if (this.loadDataOnInit == true) {
        this.load(this.value);
      }
      $("#select_" + this.getId()).unbind().change(this.onChange);
      this.placeholder = this.$store.translate('select_location');
      this.buttontext = this.$store.translate('add_location');
    }
  };
</script>

<style scoped>
  .select_container {
    width: 100%;
  }
</style>




// WEBPACK FOOTER //
// src/components/location/location-selector.vue